<template>
    <slot
        :bonusId="bonusId"
        :deleteConfirm="deleteConfirm"
        :deleteBonus="deleteBonus"
        :openform="openform"
        :displayform="displayform"
        :editingBonus="editingBonus"
        :closeform="closeform"
        :units="units"
        :acodes="acodes"
    ></slot>
</template>
<script>
import { ListingEvent } from 'js/types/events';
import Accounting from 'api/accounting';

export default {
    data() {
        return {
            displayform: false,
            editingBonus: 0,
            deleteConfirm: false,
            bonusId: 0,
            units: {},
            acodes: {},
        };
    },
    created() {
        this.loadunits();
        this.loadaccountcodes();

        EventBus.on('bonus:update', (data) => {
            if (this.displayform) {
                this.closeform();
            }
            this.editingBonus = data.params.bonusId;
            this.displayform = true;
        });

        EventBus.on('bonus:delete', (data) => {
            this.confirmDeleteBonus(data.params.bonusId);
        });
    },

    methods: {
        loadunits() {
            this.$ajax.get(`/rest/unit`, {}, (data) => {
                this.units = data;
            });
        },

        loadaccountcodes() {
            Promise.all([
                Accounting.getAllAccountingCodes(
                    { limit: 100, order: 'code' },
                    { filters: { views: ['third'] } },
                ),
            ]).then((response) => {
                this.acodes = response[0];
            });
        },

        openform() {
            this.displayform = true;
        },

        closeform() {
            this.displayform = false;
            this.editingBonus = false;
        },

        confirmDeleteBonus(bonusId) {
            if (bonusId != 0) {
                this.bonusId = bonusId;
                this.deleteConfirm = true;
            }
        },

        deleteBonus(payload) {
            axios.delete(`/bonuses/${payload.relatedid}`).then((response) => {
                this.deleteConfirm = false;
                Push.success('Bonus supprimé');
                EventBus.emit(ListingEvent.REFRESH);
            });
        },
    },
};
</script>
